export default __webpack_public_path__ + "static/lysicrates-james-martin-statue-240a036301de305fbf1ee17421493a41.png";